import { render } from "./V3ColorPicker.vue?vue&type=template&id=25ee5c74"
import script from "./V3ColorPicker.vue?vue&type=script&lang=js"
export * from "./V3ColorPicker.vue?vue&type=script&lang=js"

import "./V3ColorPicker.vue?vue&type=style&index=0&id=25ee5c74&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__